






import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import * as config from './config';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo } from '@/common/ts/common';
@Component({
  components: {
    VoteList,
  },
})
export default class Works extends Vue {
  option = config.OPTHINES;
  created() {
    autoOpenApp();
    // 分享
    appShare({
      title: '重庆体彩特约上游运动家短视频挑战赛',
      url: window.location.href,
      subtitle: '重庆体彩特约上游运动家短视频挑战赛',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '重庆体彩特约上游运动家短视频挑战赛',
      subtitle: '重庆体彩特约上游运动家短视频挑战赛',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
